export type SuggestedNameKind = 'canvas' | 'design' | 'proposal';

const NAME_PATTERN = /^(Canvas|Design|Proposal)\s+(\d{6})-(\d+)$/i;

export function formatDesignDateStamp(date: Date = new Date()): string {
  const yy = String(date.getFullYear()).slice(-2);
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yy}${mm}${dd}`;
}

export function nextSequenceForLeadNames(
  existingNames: readonly string[],
  kind: SuggestedNameKind
): number {
  const prefix =
    kind === 'canvas' ? 'Canvas' : kind === 'design' ? 'Design' : 'Proposal';
  let max = 0;
  for (const name of existingNames) {
    const match = NAME_PATTERN.exec(String(name || '').trim());
    if (!match) continue;
    if (match[1].toLowerCase() !== prefix.toLowerCase()) continue;
    const n = Number(match[3]);
    if (Number.isFinite(n) && n > max) max = n;
  }
  return max + 1;
}

export function suggestedNameForLead(options: {
  kind: SuggestedNameKind;
  existingNames: readonly string[];
  date?: Date;
  leadAddress?: string | null;
  isFirstCanvas?: boolean;
}): string {
  const {
    kind,
    existingNames,
    date = new Date(),
    leadAddress,
    isFirstCanvas
  } = options;
  if (kind === 'canvas' && isFirstCanvas) {
    const address = String(leadAddress || '').trim();
    if (address) return address;
  }
  const prefix =
    kind === 'canvas' ? 'Canvas' : kind === 'design' ? 'Design' : 'Proposal';
  const stamp = formatDesignDateStamp(date);
  const seq = nextSequenceForLeadNames(existingNames, kind);
  return `${prefix} ${stamp}-${seq}`;
}
